import { render, staticRenderFns } from "./WolfModal.vue?vue&type=template&id=34ae82f4&scoped=true&"
import script from "./WolfModal.vue?vue&type=script&lang=js&"
export * from "./WolfModal.vue?vue&type=script&lang=js&"
import style0 from "./WolfModal.vue?vue&type=style&index=0&id=34ae82f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae82f4",
  null
  
)

export default component.exports